import { Fragment, h } from "preact";
import { useState } from "preact/hooks";
import { useDispatch } from "react-redux";

import BackButton from "../BackButton.jsx";
import Button from "../Button.jsx";
import TextField from "../TextField.jsx";

import i18n from "../../i18n.js";
import { setLoading, setUser } from "../../store";
import registrationApi from "../../api/registration";
import Alert from "../Alert.jsx";

export default function RegistrationLogIn({
  goTo,
  headContent,
  onBack,
  onNext,
  setError,
  error,
  email,
  setEmail,
}) {
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();

  async function handleSubmit(event) {
    event.preventDefault();
    setError(null);

    try {
      dispatch(setLoading(true));
      const { user } = await registrationApi.signIn(email, password);
      dispatch(setUser(user));

      onNext();
    } catch (err) {
      setError(err);
    }
    dispatch(setLoading(false));
  }

  return (
    <Fragment>
      {headContent}

      {error && error.error && (
        <Alert error class="mb-16">
          {error.error}
        </Alert>
      )}

      <TextField
        name="email"
        label={i18n.t("component.task_modules.registration.labels.email")}
        error={error && error.email}
        type="text"
        value={email}
        onChange={(event) => setEmail(event.target.value)}
      />
      <TextField
        name="password"
        label={i18n.t("component.task_modules.registration.labels.password")}
        error={error && error.password}
        type="password"
        value={password}
        onChange={(event) => setPassword(event.target.value)}
        revealable
      />
      <p class="t-body4 mb-48 text-right">
        <a
          href="#"
          onClick={(event) => {
            event.preventDefault();
            goTo("forgotPassword");
          }}
        >
          {i18n.t("component.task_modules.registration.forgot_password")}
        </a>
      </p>

      <p class="mt-48">
        <BackButton noIndent onClick={onBack} />
        <Button onClick={handleSubmit}>
          {i18n.t("component.task_modules.registration.submit_button.log_in")}
        </Button>
      </p>

      <p class="t-body4 mt-48">
        {i18n.t("component.task_modules.registration.dont_have_account")}{" "}
        <a
          href="#"
          onClick={(event) => {
            event.preventDefault();
            goTo("register");
          }}
        >
          {i18n.t("component.task_modules.registration.sign_up")}
        </a>
      </p>
    </Fragment>
  );
}
